export function isDiscountValid(startDate, endDate) {
  if (!startDate || !endDate) return false;

  const nowLocal = new Date();

  const startLocal = new Date(new Date(startDate).toLocaleString());
  const endLocal = new Date(new Date(endDate).toLocaleString());

  if (isNaN(startLocal.getTime()) || isNaN(endLocal.getTime())) return false;

  return nowLocal >= startLocal && nowLocal <= endLocal;
}